// Dev
// export const baseUrl = "https://mainetti.1hour.in/api/";


// Local environment
// export const baseUrl = "http://localhost:4022/";

// UAT
// export const baseUrl = "http://10.0.0.4/api/";
export const baseUrl = "https://lca.mainetti.com/api/";
